"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuotePremiumOutput = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var commonFunctions_1 = require("../../../commonFunctions");
var services_1 = require("@falcon/services");
var AggregatorReferenceWidget_1 = require("../common/AggregatorReferenceWidget");
var TrustpilotWidget_1 = require("../../../components/TrustpilotWidget");
var QuotePremiumOutput = /** @class */ (function (_super) {
    __extends(QuotePremiumOutput, _super);
    function QuotePremiumOutput(props) {
        return _super.call(this, props) || this;
    }
    QuotePremiumOutput.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "home-premium-output quote-premium-output" },
                React.createElement("div", { className: "top-section" },
                    React.createElement("div", { className: "premium-info premium-info-home" }, this.renderFirstMonthPrice())),
                React.createElement("div", { className: "bottom-section bottom-section-annual-home" }, this.renderExcess())),
            React.createElement("p", { className: "font-weight-bold mb-0 mt-4" }, "You can select your cover level below"),
            React.createElement("p", null,
                "We\u2019ve been given the prestigious Defaqto 5 Star Rating for our ",
                React.createElement("span", { className: "font-weight-bold" }, "Allianz Silver "),
                " and ",
                React.createElement("span", { className: "font-weight-bold" }, "Allianz Gold "),
                " insurance."),
            React.createElement("div", { className: "premium-output" },
                React.createElement("div", { className: "flex-logo-container" },
                    React.createElement("div", null,
                        React.createElement(TrustpilotWidget_1.default, null)),
                    React.createElement("img", { src: "/img/DefaqtoLogoHome.svg", alt: "Home Defaqto logo", className: "logo-img" })))));
    };
    QuotePremiumOutput.prototype.renderExcess = function () {
        var policyHolder = this.props.interaction.policyHolder;
        var realEstate = this.props.interaction.realEstate[0];
        var buildings = (0, commonFunctions_1.getCoverLimitAmount)("BUILDINGS_CONTENTS", "BUILDINGS_LIMIT", this.props.interaction);
        var contents = (0, commonFunctions_1.getCoverLimitAmount)("BUILDINGS_CONTENTS", "CONTENTS_LIMIT", this.props.interaction);
        return (React.createElement("div", null,
            React.createElement("div", { className: "text-center" },
                React.createElement("p", { className: "mb-0 font-weight-bold" }, this.getCoverWording()),
                React.createElement("p", { className: "mb-0" },
                    React.createElement("span", { className: "font-weight-bold" },
                        policyHolder.firstName,
                        " ",
                        policyHolder.lastName),
                    " (policyholder)"),
                React.createElement("p", { className: "mb-0" }, realEstate.address.fullAddress),
                React.createElement("p", { className: "mb-0" },
                    React.createElement("span", { className: "font-weight-bold" }, (0, commonFunctions_1.getAmountToDisplay)(buildings)),
                    " Buildings"),
                React.createElement("p", { className: "mb-0" },
                    React.createElement("span", { className: "font-weight-bold" }, (0, commonFunctions_1.getAmountToDisplay)(contents)),
                    " Contents"),
                services_1.resourcesHelper.THEME === "Flow" && React.createElement("p", { className: "text-center mb-0 pt-2 pb-2" }, "*All figures include Insurance Premium Tax."))));
    };
    QuotePremiumOutput.prototype.renderFirstMonthPrice = function () {
        var isMonthly = this.props.interaction.factors.premiumType === services_1.PREMIUM_TYPE_MONTHLY;
        var isAnnual = this.props.interaction.factors.premiumType === services_1.PREMIUM_TYPE_ANNUAL;
        var totalPremium = this.props.interaction.paymentDetails.instalmentPlan && this.props.interaction.paymentDetails.instalmentPlan.totalAmount;
        var creditCost = this.props.interaction.paymentDetails.instalmentPlan && this.props.interaction.paymentDetails.instalmentPlan.creditCost;
        var deposit = this.props.interaction.paymentDetails.instalmentPlan && this.props.interaction.paymentDetails.instalmentPlan.deposit;
        return (React.createElement("div", null,
            React.createElement(AggregatorReferenceWidget_1.AggregatorReferenceWidget, { source: this.props.interaction.source }),
            isMonthly &&
                React.createElement("div", { className: "monthly-quote-price" },
                    React.createElement("div", null,
                        React.createElement("div", { id: "price", className: "price-home text-center font-family-display font-weight-bold pt-3" },
                            (0, commonFunctions_1.getAmountWithDecimalDigits)(this.props.interaction.factors.monthlyPremium),
                            React.createElement("span", { className: "muli-bold-16" }, " / month*")),
                        React.createElement("p", { className: "text-center mb-0 pt-1" },
                            React.createElement("span", { className: "muli-bold-16" }, (0, commonFunctions_1.getAmountWithDecimalDigits)(deposit)),
                            " deposit"),
                        React.createElement("p", { className: "text-center mb-0" },
                            React.createElement("span", { className: "muli-bold-16" }, (0, commonFunctions_1.getAmountWithDecimalDigits)(totalPremium)),
                            " in total,"),
                        React.createElement("p", { className: "text-center mb-0" },
                            React.createElement("span", { className: "muli-bold-16" }, (0, commonFunctions_1.getAmountWithDecimalDigits)(creditCost)),
                            " more than paying annually")),
                    React.createElement("p", { className: "mb-0 all-figures" }, "*All figures include Insurance Premium Tax.")),
            isAnnual && this.getAnnualWording()));
    };
    QuotePremiumOutput.prototype.getAnnualWording = function () {
        var isAnnualOnly = this.props.interaction.radarPolicyData.instalmentAllowedStatus === 'N' || this.props.interaction.radarPolicyData.instalmentAllowedStatus === 'D';
        return (React.createElement("div", null,
            React.createElement("div", null,
                React.createElement("div", { id: "price", className: "price-home text-center font-family-display font-weight-bold pt-5" },
                    (0, commonFunctions_1.getAmountWithDecimalDigits)(this.props.interaction.factors.annualPremium),
                    " ",
                    React.createElement("span", { className: "muli-bold-16" }, "/ year*"))),
            isAnnualOnly &&
                React.createElement("p", { className: "mb-0 all-figures font-weight-bold" }, "Sorry, we can\u2019t offer you a monthly plan"),
            React.createElement("p", { className: "mb-0 all-figures" }, "*All figures include Insurance Premium Tax.")));
    };
    QuotePremiumOutput.prototype.getCoverWording = function () {
        var coverTier = this.props.interaction.coverTier;
        if (coverTier === services_1.BRONZE_TIER) {
            return "Allianz Bronze Cover";
        }
        else if (coverTier === services_1.SILVER_TIER) {
            return "Allianz Silver Cover";
        }
        else if (coverTier === services_1.GOLD_TIER) {
            return "Allianz Gold Cover";
        }
        return "";
    };
    return QuotePremiumOutput;
}(plugin_journey_1.WidgetBase));
exports.QuotePremiumOutput = QuotePremiumOutput;
//# sourceMappingURL=QuotePremiumOutput.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/home/QuotePremiumOutput.js
// module id = 3687
// module chunks = 0